export default "__VITE_ASSET__DAsvSc9s__"